export const APPROVAL_FLOWS_BY_REQUESTOR =
  '/api/approval-service/approval-flow/approval-flows';

export const SEND_FOR_APPROVAL_FLOW =
  '/api/approval-service/approval-process/send-for-approval';

export const GET_APPROVAL_FLOW_STATUS =
  '/api/approval-service/approval-process/check-status';

export const CHANGE_APPROVAL_FLOW_STATUS =
  '/api/approval-service/approval-process/change-status';

export const DELETE_APPROVAL_PROCESS = '/api/approval-service/approval-process';
export const USERS = '/api/authentication/v1/users/';
export const SOCKET_SERVICE = '/api/approval-service/socket-io';
export const SEND_REMINDER_EMAIL =
  '/api/approval-service/approval-process/remind_approver';
